import React from 'react';

const VerificationIcon = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // Spread props to allow customization
  >
    <rect width="64" height="64" rx="32" fill="#1B07EE" />
    <path
      d="M45.3333 33.6667C45.3333 42 39.5 46.1667 32.5667 48.5833C32.2036 48.7064 31.8092 48.7005 31.45 48.5667C24.5 46.1667 18.6667 42 18.6667 33.6667V22C18.6667 21.0801 19.4135 20.3333 20.3333 20.3333C23.6667 20.3333 27.8333 18.3333 30.7333 15.8C31.4628 15.1768 32.5372 15.1768 33.2667 15.8C36.1833 18.35 40.3333 20.3333 43.6667 20.3333C44.5865 20.3333 45.3333 21.0801 45.3333 22"
      stroke="white"
      strokeWidth="3.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27 32L30.3333 35.3333L37 28.6667"
      stroke="white"
      strokeWidth="3.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default VerificationIcon;
